import { render } from "./poster.vue?vue&type=template&id=6cacd1d7&scoped=true"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"

import "./poster.vue?vue&type=style&index=0&id=6cacd1d7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cacd1d7"

export default script